"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentContentProvider = void 0;
const BaseDataProvider_1 = require("./BaseDataProvider");
class AssignmentContentProvider extends BaseDataProvider_1.BaseDataProvider {
    constructor(refs, connectivityService) {
        super(refs, connectivityService);
    }
    content(id) {
        return this.docPromise(this.refs.assignmentContentDocument(id));
    }
    contentStream(id) {
        return this.docDataStream(this.refs.assignmentContentDocument(id), false);
    }
}
exports.AssignmentContentProvider = AssignmentContentProvider;
//# sourceMappingURL=AssignmentContentProvider.js.map